<template>
  <div class= "personnelAllotment">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="deptnameValue" :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_isDeptName')">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.lab_isDeptName')" value></el-option>
            <el-option
                v-for="(item,index) in deptnames"
                :key="index"
                :label="item.DeptName"
                :value="item.DeptName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="titleValue" :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_isTitle')">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.lab_isTitle')" value></el-option>
            <el-option
                v-for="(item,index) in titles"
                :key="index"
                :label="item.Title"
                :value="item.Title"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="keyName" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_isName')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="keyStaffID" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_isStaffId')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="keyMobile" :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_isMobile')"></el-input>
        </el-form-item>
        <el-button type="primary" @click="search">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
      >
        <el-table-column type="selection" width="55" v-if="personnelAllotmentcheckbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <el-table-column
          prop="staffId"
          :label="$t('lang.lab_isStaffId')">
        </el-table-column>
        <el-table-column
          prop="deptName"
          :label="$t('lang.lab_isDeptName')">
        </el-table-column>
        <el-table-column
          prop="title"
          :label="$t('lang.lab_isTitle')">
        </el-table-column>
        <el-table-column
          prop="name"
          :label="$t('lang.lab_isName')">
        </el-table-column>
        <el-table-column
          prop="mobile"
          :label="$t('lang.lab_isMobile')">
        </el-table-column>
        <el-table-column
          prop="hiredDate"
          :label="$t('lang.lab_isHiredDate')"
          sortable>
          <template slot-scope="scope">
            {{ scope.row.hiredDate | timeYMD }}
          </template>
        </el-table-column>
        <el-table-column
          prop="bindId"
          :label="$t('lang.lab_isBindId')"
          width="200px">
          <template slot-scope="scope">
            <span class="bindRed" v-if="scope.row.bindId === null">{{$t('lang.lab_isBindNO')}}</span>
            <span class="bindGreen" v-else>{{$t('lang.lab_isBindYES')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width1">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)" v-if="scope.row.bindId === null">{{$t('lang.lab_isBindAPP')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="sizes, prev, pager, next, jumper"
          :page-count="pageCount"
      />
    </el-card>
  </div>
</template>
<script>
/**
 *@ClassName:personnelAllotment
*@Description:人事信息
*@author:宋莎
*@Copyright:格众科技
*@date:2020-03-19
*/
import { mapGetters } from 'vuex'

export default {
  name:'/manage/main.hrList',
  data() {
    return {
      multipleSelection: [], // 多选框
      personnelAllotmentcheckbox: require('@/config/enum').personnelAllotmentcheckbox, // 是否隐藏复选框
      tableData: [], // list
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      pageCount: 0, // 总页数
      deptnames: [], // 部门数据
      titles: [], // 职务数据
      deptnameValue: '', // 绑定部门
      titleValue: '', // 绑定职务
      keyName: '', // 检索词姓名
      keyStaffID: '', // 检索词员工编号
      keyMobile: '', // 检索词电话
    }
  },
  created() {
    this.deptname()
    this.title()
    this.getData()
  },
  computed: {
      ...mapGetters(['gardenId'])
    },
  watch: {
    gardenId: function (newFlag, oldFlag) {
      this.commit()
    }
  },
  methods: {
    // 进入页面后默认显示
    getData() {
      let loading = this.$loading()
      this.$get(`/hr/page?pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )   
    },
    // 获取部门
    deptname() {
      let loading = this.$loading()
      this.$get(`/hr/getDeptNameList`).then(
        res => {
          loading.close()
          if (res) {
            this.deptnames = res
          }
        }, error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 获取职务
    title() {
      let loading = this.$loading()
      this.$get(`/hr/getTitleList`).then(
        res => {
          loading.close()
          if (res) {
            this.titles = res
          }
        }, error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 筛选      
    search() {
      this.pageNo = 1
      let loading = this.$loading()
      this.$get(`/hr/page?${this.pageNo}&pageSize=${this.pageSize}&Name=${this.keyName}&StaffId=${this.keyStaffID}&DeptName=${this.deptnameValue}&Mobile=${this.keyMobile}&Title=${this.titleValue}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    }, 
    // 更新
    commit() {
      this.pageNo = 1
      this.getData()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getData()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getData()
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
  },
}
</script>

<style lang="scss">
.personnelAllotment {
  .bindRed{
    color: red;
  }
  .bindGreen{
    color: green;
  }
}
</style>